import type { FlexProps } from '@chakra-ui/react';
import { Box, Flex } from '@chakra-ui/react';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useScrollContainer } from 'react-indiana-drag-scroll';

export type CalendarYearBarProps = FlexProps & {
  minDate: Date;
  maxDate: Date;
  year: number;
  onYearChange: (year: number) => void;
};
export const CalendarYearBar: FC<CalendarYearBarProps> = ({
  minDate,
  maxDate,
  onYearChange,
  year: currentYear,
  ...props
}) => {
  const maxYear = maxDate.getFullYear();
  const minYear = minDate.getFullYear();
  const years = useMemo(() => {
    const years: number[] = [];
    for (let i = maxYear; i >= minYear; i--) {
      years.push(i);
    }
    return years;
  }, [maxYear, minYear]);

  const scrollContainer = useScrollContainer();

  return (
    <Flex
      ref={scrollContainer.ref}
      className="no-scrollbar"
      gap="16px"
      flexWrap="nowrap"
      overflowX="auto"
      {...props}
    >
      {years.map((year, index) => {
        const isActive = year === currentYear;
        return (
          <Box
            key={index}
            rounded="9999px"
            p="6px 16px"
            textStyle="ctaCopy"
            borderWidth="1px"
            borderColor="brand-primary"
            bg={isActive ? 'brand-primary' : undefined}
            color={isActive ? 'white' : 'brand-primary'}
            cursor="pointer"
            onClick={() => {
              onYearChange(year);
            }}
          >
            {year}
          </Box>
        );
      })}
    </Flex>
  );
};
